/* global Swiper */

itsoftApp.createModule("jsslider1", ["slidersLibrary"], function() {
    var noPreparing = function(){
        $("body").removeClass("is-preparing");
    };

    var sliderParent = $(".js-slider-1");

    if (!sliderParent.length) {
        noPreparing();
        return false;
    }

    var box = $(".js-portfolio");
    var heder = $(".js-header");
    var noActiveClass = "no-active";
    var swiper;
    var top = $(".js-top");
    var initialized = false;
    var widthControl;

    var slideControl = function(perent){
        perent.on("slideChangeStart", function() {
            if(box.hasClass("swiper-slide-active")){
                heder.addClass(noActiveClass);
            }
            else{
                heder.removeClass(noActiveClass);
            }
        });
    }

    var init = function() {
        initialized = true;
        swiper = new Swiper(sliderParent.get(0), {
            pagination: ".swiper-pagination1",
            paginationClickable: true,
            direction: "vertical",
            mousewheelControl: true,
            nextButton: ".js-button-next",
            keyboardControl: true,
            onSlideNextEnd: onSlideNextEnd,
            onSlidePrevStart: onSlidePrevStart,
            onTouchStart:onTouchStart,
            onTouchEnd: onTouchEnd,


        });
        DEBUG && console.log("[module swiper] slider1 initialized");

        slideControl(swiper);
        noPreparing();
    };

    var loadAndInit = function() {
        itsoftApp.modules.slidersLibrary.addEvent(init);
    };


    var resizeController = function() {
        var w = window.innerWidth;

        if (w > 760) {

            if (!initialized) {
                loadAndInit();
            }
            widthControl = true;

        } else {
            widthControl = false;
            noPreparing();
            if (initialized) {
                if (swiper !== undefined) {
                    swiper.destroy(true, true);
                    DEBUG && console.log("%c[module swiper] slider #1 destroyed", "color: #777");
                }

                initialized = false;

                DEBUG && console.log("[module swiper] sliders destroyed");
            }
        }
    };

    top.on("click", function(){
        if (widthControl)
        {
            swiper.slideTo(0, 500);
        }
    });

    resizeController();
    itsoftApp.modules.windowResize.addEvent(resizeController);

    var activeIndex = undefined;
    var popupOpened = false;

    var touchstartX = 0;
    var touchstartY = 0;
    var touchendX = 0;
    var touchendY = 0;

    var popupToShow = $("#contacts");

    var onSlideNextEnd = function() {
        DEBUG && console.log("onSlideNextEnd");
        activeIndex = swiper.activeIndex;

    };
    var onSlidePrevStart = function() {
        DEBUG && console.log("onSlidePrevStart");
        activeIndex = swiper.activeIndex;
    };
    var onTouchStart = function(swiper, event) {
        if (activeIndex != swiper.slides.length - 1)
            {return}
        DEBUG && console.log("onTouchStart");
        touchstartX = event.screenX;
        touchstartY = event.screenY;

        DEBUG && console.log("touchstartX = " + touchstartX);
        DEBUG && console.log("touchstartY = " + touchstartY);

    };
    var onTouchEnd = function(swiper, event) {
        if (activeIndex != swiper.slides.length - 1)
            {return}
        DEBUG && console.log("onTouchEnd");

        touchendX = event.screenX;
        touchendY = event.screenY;

        DEBUG && console.log("touchendX = " + touchendX);
        DEBUG && console.log("touchendY = " + touchendY);
        handleGesure();
    };

    var wheelController = function(e) {
        if (!widthControl){
            return;
        }

        var deltaY = e.originalEvent.deltaY

        if (deltaY <= 0 || activeIndex != swiper.slides.length - 1) {
            return;
        }

        if (!popupOpened) {
            popupToShow.trigger("popups:open");
        }
    };

    var openPopup = function() {
        if (popupOpened) {
            return;
        }
        popupOpened = true;

        DEBUG && console.log("%c[module jsslider1] popup opened", "color: orange");

        setTimeout(function(){popupToShow.removeClass("g-no-scroll");}, 1000);
    };

    var closePopup = function() {
        if (!popupOpened) {
            return;
        }
        popupOpened = false;
        DEBUG && console.log("%c[module jsslider1] popup closed", "color: orange");
        popupToShow.addClass("g-no-scroll");
    };

    sliderParent.on("wheel", wheelController);
    popupToShow.on("popups:open", openPopup);
    popupToShow.on("popups:close", closePopup);

    // $(".js-button-next").on("click", function(){
    //     if ($(this).hasClass("swiper-button-disabled")){
    //         if (!popupOpened) {
    //             popupToShow.trigger("popups:open");
    //         }
    //     }
    // })

    function handleGesure() {
        var swiped = "swiped: ";
        if (touchendY < touchstartY && activeIndex == swiper.slides.length - 1) {
            if (!popupOpened) {
                popupToShow.trigger("popups:open");
            }
        }
    }


});
